import React from 'react';
import { useTranslation } from 'react-i18next';

const UnconfirmedEmailComponent = () => {
    const [t] = useTranslation();

    // create translated message with unescaped html profile link
    const resendEmailMessage = 
        t('details_email_unconfirmed_warning_b', {
            0 : `<a href="Account/ProfileDetails">${t('link_profile')}</a>`,
            interpolation: {
                prefix: '{',
                suffix: '}',
                escapeValue: false
            }
        });

    return(
        <div className={'alert alert-warning'}>
            {t('unverified_email_message')}
            <p dangerouslySetInnerHTML = {{__html: resendEmailMessage}} />
        </div>
    );
};

export default UnconfirmedEmailComponent;